var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:_vm.$classes(),style:(_vm.textStyles()),attrs:{"href":_vm.$href(),"rel":_vm.$rel()},on:{"click":function($event){return _vm.$onClick()}}},[_vm._v("\n  "+_vm._s(_vm.spec.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }